export default [
  {
    path: '/sign_in',
    name: 'Login',
    component: () => import('@/views/adm/auth/login/Login.vue')
  }
]